//
//  DocumentationLegacyPageBlock.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlockType } from "../../enums/SDKDocumentationLegacyPageBlockType";
import { DocumentationLegacyPageBlockAssets, } from "../blocks/SDKDocumentationLegacyPageBlockAssets";
import { DocumentationLegacyPageBlockCallout, } from "../blocks/SDKDocumentationLegacyPageBlockCallout";
import { DocumentationLegacyPageBlockCode, } from "../blocks/SDKDocumentationLegacyPageBlockCode";
import { DocumentationLegacyPageBlockColumn } from "../blocks/SDKDocumentationLegacyPageBlockColumn";
import { DocumentationLegacyPageBlockColumnItem, } from "../blocks/SDKDocumentationLegacyPageBlockColumnItem";
import { DocumentationLegacyPageBlockCustom, } from "../blocks/SDKDocumentationLegacyPageBlockCustom";
import { DocumentationLegacyPageBlockDivider } from "../blocks/SDKDocumentationLegacyPageBlockDivider";
import { DocumentationLegacyPageBlockEmbedFigma, } from "../blocks/SDKDocumentationLegacyPageBlockEmbedFigma";
import { DocumentationLegacyPageBlockEmbedGeneric, } from "../blocks/SDKDocumentationLegacyPageBlockEmbedGeneric";
import { DocumentationLegacyPageBlockEmbedLink, } from "../blocks/SDKDocumentationLegacyPageBlockEmbedLink";
import { DocumentationLegacyPageBlockEmbedStorybook, } from "../blocks/SDKDocumentationLegacyPageBlockEmbedStorybook";
import { DocumentationLegacyPageBlockEmbedYoutube, } from "../blocks/SDKDocumentationLegacyPageBlockEmbedYoutube";
import { DocumentationLegacyPageBlockFrames, } from "../blocks/SDKDocumentationLegacyPageBlockFrames";
import { DocumentationLegacyPageBlockHeading, } from "../blocks/SDKDocumentationLegacyPageBlockHeading";
import { DocumentationLegacyPageBlockImage, } from "../blocks/SDKDocumentationLegacyPageBlockImage";
import { DocumentationLegacyPageOrderedList } from "../blocks/SDKDocumentationLegacyPageBlockOrderedList";
import { DocumentationLegacyPageBlockQuote, } from "../blocks/SDKDocumentationLegacyPageBlockQuote";
import { DocumentationLegacyPageBlockRenderCode, } from "../blocks/SDKDocumentationLegacyPageBlockRenderCode";
import { DocumentationLegacyPageBlockShortcuts, } from "../blocks/SDKDocumentationLegacyPageBlockShortcuts";
import { DocumentationLegacyPageBlockTab } from "../blocks/SDKDocumentationLegacyPageBlockTab";
import { DocumentationLegacyPageBlockTabItem, } from "../blocks/SDKDocumentationLegacyPageBlockTabItem";
import { DocumentationLegacyPageBlockTable, } from "../blocks/SDKDocumentationLegacyPageBlockTable";
import { DocumentationLegacyPageBlockTableCell, } from "../blocks/SDKDocumentationLegacyPageBlockTableCell";
import { DocumentationLegacyPageBlockTableRow } from "../blocks/SDKDocumentationLegacyPageBlockTableRow";
import { DocumentationLegacyPageBlockText, } from "../blocks/SDKDocumentationLegacyPageBlockText";
import { DocumentationLegacyPageBlockToken, } from "../blocks/SDKDocumentationLegacyPageBlockToken";
import { DocumentationLegacyPageBlockTokenGroup, } from "../blocks/SDKDocumentationLegacyPageBlockTokenGroup";
import { DocumentationLegacyPageBlockTokenList, } from "../blocks/SDKDocumentationLegacyPageBlockTokenList";
import { DocumentationLegacyPageUnorderedList, } from "../blocks/SDKDocumentationLegacyPageBlockUnorderedList";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyBlockBuilder {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Static
    static fromGenericModel(model, customBlocks, configuration) {
        var _a;
        // Map children. Children that are not supported by the data model natively should be ignored
        const children = (_a = model.children) === null || _a === void 0 ? void 0 : _a.map((c) => DocumentationLegacyBlockBuilder.fromGenericModel(c, customBlocks, configuration)).filter((c) => c !== undefined);
        switch (model.type) {
            case DocumentationLegacyPageBlockType.text:
                return new DocumentationLegacyPageBlockText(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.heading:
                return new DocumentationLegacyPageBlockHeading(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.code:
                return new DocumentationLegacyPageBlockCode(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.unorderedList:
                return new DocumentationLegacyPageUnorderedList(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.orderedList:
                return new DocumentationLegacyPageOrderedList(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.quote:
                return new DocumentationLegacyPageBlockQuote(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.callout:
                return new DocumentationLegacyPageBlockCallout(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.divider:
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                return new DocumentationLegacyPageBlockDivider(model, children);
            case DocumentationLegacyPageBlockType.image:
                return new DocumentationLegacyPageBlockImage(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.link:
                return new DocumentationLegacyPageBlockEmbedLink(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.token:
                return new DocumentationLegacyPageBlockToken(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.tokenGroup:
                return new DocumentationLegacyPageBlockTokenGroup(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.tokenList:
                return new DocumentationLegacyPageBlockTokenList(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.shortcuts:
                return new DocumentationLegacyPageBlockShortcuts(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.figmaEmbed:
                return new DocumentationLegacyPageBlockEmbedFigma(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.youtubeEmbed:
                return new DocumentationLegacyPageBlockEmbedYoutube(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.storybookEmbed:
                return new DocumentationLegacyPageBlockEmbedStorybook(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.genericEmbed:
                return new DocumentationLegacyPageBlockEmbedGeneric(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.figmaFrames:
                return new DocumentationLegacyPageBlockFrames(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.componentAssets:
                return new DocumentationLegacyPageBlockAssets(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.custom:
                return new DocumentationLegacyPageBlockCustom(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children, customBlocks);
            case DocumentationLegacyPageBlockType.renderCode:
                return new DocumentationLegacyPageBlockRenderCode(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children, configuration);
            case DocumentationLegacyPageBlockType.column:
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                return new DocumentationLegacyPageBlockColumn(model, children);
            case DocumentationLegacyPageBlockType.columnItem:
                return new DocumentationLegacyPageBlockColumnItem(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.tabs:
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                return new DocumentationLegacyPageBlockTab(model, children);
            case DocumentationLegacyPageBlockType.tabItem:
                return new DocumentationLegacyPageBlockTabItem(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.table:
                return new DocumentationLegacyPageBlockTable(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.tableCell:
                return new DocumentationLegacyPageBlockTableCell(model, 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
            case DocumentationLegacyPageBlockType.tableRow:
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                return new DocumentationLegacyPageBlockTableRow(model, children);
            default:
                // Create a default empty text block in place of unsupported blocks
                return new DocumentationLegacyPageBlockText(Object.assign(Object.assign({}, model), { text: {
                        spans: [],
                    } }), 
                // @ts-expect-error TS(2345): Argument of type 'DocumentationLegacyPageBlock[] |... Remove this comment to see the full error message
                children);
        }
    }
}
